/**
 * External dependencies
 */
import type { ScopeRule } from '@nab/types';

export type ScopeAction = SetScopeRules;

export function setScopeRules(
	rules: ReadonlyArray< ScopeRule >
): SetScopeRules {
	return {
		type: 'SET_SCOPE_RULES',
		rules,
	};
}

// =====
// TYPES
// =====

type SetScopeRules = {
	readonly type: 'SET_SCOPE_RULES';
	readonly rules: ReadonlyArray< ScopeRule >;
};
